import api from '@api';

export const generateFinancialReports = async ({
  token,
  payload,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      timeout: 0,
    };
    const response = await axiosInstance.post(
      `/admin/financial-reports/download-reports`,
      payload,
      config,
    );

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};
